module.exports = __webpack_public_path__ + "img/background-5.420acf6d.png";